module.exports = "/_next/static/images/Trend02Visual-29ed54feea2f195862bc0cf08c028c7a.webp";